/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { useLocalStorage } from "../hooks/useLocalStorage"
import { Spacer } from "@cd2/components"
import { useGlobalState } from "./GlobalStateProvider"
import ReactJson from "react-json-view"

interface IDebugPanelProps {
  data: Record<string, any>
}

export function DebugPanel({ data }: IDebugPanelProps) {
  const { currentUser } = useGlobalState()

  const [open, setOpen] = useLocalStorage("debug-open", false)
  const [pos, setPos] = useLocalStorage("debug-position", "tr")

  if (!(currentUser.isSuperAdmin || process.env.NODE_ENV === "development")) {
    return null
  }

  return (
    <div
      css={css`
        position: fixed;
        top: ${pos.includes("t") ? 0 : "initial"};
        right: ${pos.includes("r") ? 0 : "initial"};
        bottom: ${pos.includes("b") ? 0 : "initial"};
        left: ${pos.includes("l") ? 0 : "initial"};
        padding: 16px 24px;
        cursor: pointer;
        color: white;
        background: rgba(45, 45, 45, 0.79);
        border-radius: 6px;
        z-index: 1000;
        overflow: auto;
        max-width: 500px;
        max-height: 500px;
      `}
    >
      <b onClick={() => setOpen(!open)}>{open ? "CLOSE" : "DEBUG"}</b>

      {open && (
        <React.Fragment>
          <Spacer size={32} horizontal />
          <select
            onChange={e => {
              setPos(e.target.value)
            }}
            onClick={e => e.stopPropagation()}
            value={pos}
          >
            <option value="bl">bottom left</option>
            <option value="br">bottom right</option>
            <option value="tl">top left</option>
            <option value="tr">top right</option>
          </select>
          <br />
          {Object.keys(data).map(heading => (
            <div
              key={heading}
              css={css`
                background: white;
                color: black;
                margin-bottom: 16px;
              `}
            >
              <b>{heading}</b>
              <ReactJson src={data[heading]} collapsed />
            </div>
          ))}
        </React.Fragment>
      )}
    </div>
  )
}
